import { useI18n } from 'vue-i18n'
import { ref, watch } from 'vue'

export function useLanguage() {
  const { locale } = useI18n()
  const currentLocale = ref(locale.value)

  // Función para cambiar el idioma
  const changeLanguage = (newLocale) => {
    locale.value = newLocale
    currentLocale.value = newLocale
    localStorage.setItem('locale', newLocale)
  }

  // Observar cambios en el locale
  watch(locale, (newLocale) => {
    currentLocale.value = newLocale
  })

  // Obtener información del idioma actual
  const getLanguageInfo = (code) => {
    const languages = {
      es: {
        name: 'Español',
        flag: '🇪🇸',
        code: 'es'
      },
      en: {
        name: 'English',
        flag: '🇺🇸',
        code: 'en'
      }
    }
    return languages[code] || languages.es
  }

  // Obtener todos los idiomas disponibles
  const getAvailableLanguages = () => {
    return [
      getLanguageInfo('es'),
      getLanguageInfo('en')
    ]
  }

  return {
    currentLocale,
    changeLanguage,
    getLanguageInfo,
    getAvailableLanguages
  }
} 